import React from 'react';

export default () => (
  <svg height="42px" width="32px" version="1.1" viewBox="0 0 45 42">
    <g id="Page-1" fill="none" stroke="none" strokeWidth="1">
      <g id="250-icons-48x48px" fill="#0074d9" transform="translate(-345.000000, -292.000000)">
        <g id="Home" transform="translate(345.000000, 292.000000)">
          <path
            id="Shape"
            d="M43.52,17.11 L24.66,1.11 C23.5407186,0.16109088 21.8992814,0.16109088 20.78,1.11 L1.92,17.11 C0.983425838,17.9079829 0.629069131,19.1969477 1.02609548,20.3615584 C1.42312183,21.526169 2.49102462,22.3302726 3.72,22.39 L3.72,38.39 C3.72,40.0468542 5.06314575,41.39 6.72,41.39 L38.72,41.39 C40.3768542,41.39 41.72,40.0468542 41.72,38.39 L41.72,22.4 C42.9489754,22.3402726 44.0168782,21.536169 44.4139045,20.3715584 C44.8109309,19.2069477 44.4565742,17.9179829 43.52,17.12 L43.52,17.11 Z M21.72,38.4 L19.72,38.4 L19.72,29.4 L25.72,29.4 L25.72,38.4 L21.72,38.4 Z M38.72,19.4 L38.72,38.4 L28.72,38.4 L28.72,29.4 C28.72,27.7431458 27.3768542,26.4 25.72,26.4 L19.72,26.4 C18.0631458,26.4 16.72,27.7431458 16.72,29.4 L16.72,38.4 L6.72,38.4 L6.72,19.4 L3.86,19.4 L22.72,3.4 L41.58,19.4 L38.72,19.4 Z"
          />
        </g>
      </g>
    </g>
  </svg>
);
